// crewbit-admin/src/pages/SetupGuide/resolvers/setupWizardResolver.ts
//
// Tier 2-UI Phase A §WorldClass.4 — resolver for the new `setup_wizard`
// SetupGuide item (Decision §A.D11). Item is "complete" when bootstrap has
// been run, proxied by businesses.activity_class IS NOT NULL (the bootstrap
// RPC body unconditionally writes activity_class via COALESCE-preserve UPDATE,
// so a non-null value is a reliable indicator the wizard ran at least once).

import type { ResolverInput, ResolverResult } from './types';

export async function resolveSetupWizardItem(
  { business }: ResolverInput,
): Promise<ResolverResult> {
  if (business.activity_class) {
    return { complete: true, reason: 'bootstrap defaults applied' };
  }
  return { complete: false, reason: 'bootstrap not run' };
}
